import type { LanguagePack } from './types'

export const kn: LanguagePack = {
  navSaved: 'ಉಳಿಸಿದವು',
  navInfo: 'ಮಾಹಿತಿ',
  homeTitle: 'ನಿಮ್ಮ ಕಾಗದದ ಫೋಟೋ ತೆಗೆಯಿರಿ',
  homeHint: 'ಅದರಲ್ಲಿ ಏನು ಬರೆದಿದೆ, ನೀವು ಮುಂದೆ ಏನು ಮಾಡಬೇಕು ಎಂದು ಸಮ್ಝೋ ಹೇಳುತ್ತದೆ.',
  takePhoto: 'ಫೋಟೋ ತೆಗೆಯಿರಿ',
  uploadFile: 'ಫೋಟೋ ಅಥವಾ PDF ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
  supportedFiles: 'ಫೋಟೋ (JPG, PNG, WEBP) ಅಥವಾ PDF · 10 MB ವರೆಗೆ',
  chooseLanguage: 'ಯಾವ ಭಾಷೆಯಲ್ಲಿ ವಿವರಿಸಬೇಕು',
  privacyLine: 'ನಿಮ್ಮ ಕಾಗದವನ್ನು ಈ ಫೋನ್‌ನಲ್ಲೇ ಓದಲಾಗುತ್ತದೆ. ನೀವು "ಸೇವ್ ಮಾಡಿ" ಒತ್ತಿದರೆ ಮಾತ್ರ ಇದು ಸೇವ್ ಆಗುತ್ತದೆ.',

  previewTitle: 'ಫೋಟೋ ಸರಿಯಾಗಿದೆಯೇ?',
  rotate: 'ತಿರುಗಿಸಿ',
  crop: 'ಕತ್ತರಿಸಿ',
  cropDone: 'ಆಯಿತು',
  retake: 'ಮತ್ತೆ ತೆಗೆಯಿರಿ',
  readNow: 'ಓದಿ',
  docLanguageLabel: 'ಕಾಗದ ಯಾವ ಭಾಷೆಯಲ್ಲಿ ಬರೆದಿದೆ?',
  docLanguageHint: 'ಇಂಗ್ಲಿಷ್ ಅನ್ನು ಯಾವಾಗಲೂ ಜೊತೆಗೆ ಓದಲಾಗುತ್ತದೆ.',

  stepCheck: 'ಫೋಟೋ ಚೆಕ್ ಮಾಡಲಾಗುತ್ತಿದೆ…',
  stepRead: 'ಕಾಗದ ಓದಲಾಗುತ್ತಿದೆ…',
  stepExtract: 'ಮುಖ್ಯ ವಿವರಗಳನ್ನು ಹುಡುಕಲಾಗುತ್ತಿದೆ…',
  stepExplain: 'ಕನ್ನಡದಲ್ಲಿ ವಿವರಿಸಲಾಗುತ್ತಿದೆ…',
  firstTimeNote: 'ಮೊದಲ ಬಾರಿ ಓದುವ ಟೂಲ್ ಡೌನ್‌ಲೋಡ್ ಆಗುವುದರಿಂದ ಸ್ವಲ್ಪ ಹೆಚ್ಚು ಸಮಯ ಆಗುತ್ತದೆ.',
  cancel: 'ರದ್ದು ಮಾಡಿ',

  errBadImage: 'ಫೋಟೋ ಸ್ವಲ್ಪ ಸ್ಪಷ್ಟವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಇನ್ನೊಂದು ಸ್ಪಷ್ಟ ಫೋಟೋ ತೆಗೆಯಿರಿ.',
  errNoText: 'ಈ ಕಾಗದದಲ್ಲಿ ಬರೆದ ಅಕ್ಷರಗಳು ಸಮ್ಝೋಗೆ ಸಿಗಲಿಲ್ಲ.',
  errUnclearPart: 'ಈ ಭಾಗವನ್ನು ಸಮ್ಝೋಗೆ ಸರಿಯಾಗಿ ಓದಲು ಆಗಲಿಲ್ಲ.',
  errUnsupportedLanguage: 'ಈ ಭಾಷೆಗೆ ಇನ್ನೂ ಸಪೋರ್ಟ್ ಇಲ್ಲ.',
  errLongDocument: 'ಈ ಕಾಗದ ತುಂಬಾ ಉದ್ದವಾಗಿದೆ. ಮೊದಲು ಮುಖ್ಯ ಪುಟಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ.',
  errFileType: 'ದಯವಿಟ್ಟು ಫೋಟೋ (JPG, PNG, WEBP) ಅಥವಾ PDF ಆಯ್ಕೆ ಮಾಡಿ.',
  errFileSize: 'ಈ ಫೈಲ್ 10 MB ಗಿಂತ ದೊಡ್ಡದಾಗಿದೆ. ದಯವಿಟ್ಟು ಚಿಕ್ಕ ಫೈಲ್ ಆಯ್ಕೆ ಮಾಡಿ.',
  errGeneric: 'ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  errOcrDownload: 'ಓದುವ ಟೂಲ್ ಡೌನ್‌ಲೋಡ್ ಆಗಲಿಲ್ಲ. ಒಮ್ಮೆ ಇಂಟರ್ನೆಟ್ ಆನ್ ಮಾಡಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  warnDark: 'ಫೋಟೋ ಕತ್ತಲಾಗಿದೆ. ಒಳ್ಳೆಯ ಬೆಳಕಿನಲ್ಲಿ ತೆಗೆದ ಫೋಟೋವನ್ನು ಚೆನ್ನಾಗಿ ಓದಬಹುದು.',
  warnBlurry: 'ಫೋಟೋ ಮಸುಕಾಗಿದೆ. ಫೋನ್ ಅಲುಗಾಡದಂತೆ ಹಿಡಿದು ಮತ್ತೆ ತೆಗೆಯಿರಿ.',
  warnSmall: 'ಫೋಟೋ ತುಂಬಾ ಚಿಕ್ಕದಾಗಿದೆ. ಕಾಗದದ ಹತ್ತಿರದಿಂದ ತೆಗೆಯಿರಿ.',
  tryAgain: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',

  pickPagesHint: (max) => `${max} ಪುಟಗಳವರೆಗೆ ಆಯ್ಕೆ ಮಾಡಿ.`,
  pageLabel: (n) => `ಪುಟ ${n}`,
  readSelectedPages: (n) => (n === 1 ? '1 ಪುಟ ಓದಿ' : `${n} ಪುಟಗಳನ್ನು ಓದಿ`),

  typeSure: (name) => `ಇದು ${name} ತರಹ ಕಾಣುತ್ತದೆ.`,
  typeMaybe: (name) => `ಇದು ${name} ಆಗಿರಬಹುದು, ಆದರೆ ಸಮ್ಝೋಗೆ ಪೂರ್ತಿ ಖಚಿತವಿಲ್ಲ.`,
  typeUnknown: 'ಇದು ಯಾವ ರೀತಿಯ ಕಾಗದ ಎಂದು ಸಮ್ಝೋಗೆ ಪೂರ್ತಿ ಖಚಿತವಿಲ್ಲ.',
  docTypes: {
    income_certificate: { name: 'ಆದಾಯ ಪ್ರಮಾಣಪತ್ರ (ಇನ್‌ಕಮ್ ಸರ್ಟಿಫಿಕೇಟ್)', about: 'ಸರ್ಕಾರಿ ದಾಖಲೆಗಳ ಪ್ರಕಾರ ಒಬ್ಬ ವ್ಯಕ್ತಿ ಅಥವಾ ಕುಟುಂಬದ ಆದಾಯ ಇದರಲ್ಲಿ ಬರೆದಿರುತ್ತದೆ.' },
    caste_certificate: { name: 'ಜಾತಿ ಪ್ರಮಾಣಪತ್ರ', about: 'ಒಬ್ಬ ವ್ಯಕ್ತಿ ಯಾವ ಜಾತಿ ಅಥವಾ ವರ್ಗಕ್ಕೆ ಸೇರಿದವರು ಎಂದು ಇದರಲ್ಲಿ ಬರೆದಿರುತ್ತದೆ.' },
    domicile_certificate: { name: 'ವಾಸಸ್ಥಳ ಪ್ರಮಾಣಪತ್ರ', about: 'ಒಬ್ಬ ವ್ಯಕ್ತಿ ಖಾಯಂ ಆಗಿ ಎಲ್ಲಿ ವಾಸಿಸುತ್ತಾರೆ ಎಂದು ಇದರಲ್ಲಿ ಬರೆದಿರುತ್ತದೆ.' },
    birth_certificate: { name: 'ಜನನ ಪ್ರಮಾಣಪತ್ರ', about: 'ಇದು ಹುಟ್ಟಿನ ಸರ್ಕಾರಿ ದಾಖಲೆ.' },
    death_certificate: { name: 'ಮರಣ ಪ್ರಮಾಣಪತ್ರ', about: 'ಇದು ಮರಣದ ಸರ್ಕಾರಿ ದಾಖಲೆ.' },
    electricity_bill: { name: 'ಕರೆಂಟ್ ಬಿಲ್', about: 'ಬಳಸಿದ ಕರೆಂಟ್ ಮತ್ತು ಕಟ್ಟಬೇಕಾದ ಹಣ ಇದರಲ್ಲಿ ಇರುತ್ತದೆ.' },
    water_bill: { name: 'ನೀರಿನ ಬಿಲ್', about: 'ಕಟ್ಟಬೇಕಾದ ನೀರಿನ ಶುಲ್ಕ ಇದರಲ್ಲಿ ಇರುತ್ತದೆ.' },
    ration_card: { name: 'ರೇಷನ್ ಕಾರ್ಡ್ ಅಥವಾ ರೇಷನ್ ಸೂಚನೆ', about: 'ಇದು ಸರ್ಕಾರಿ ರೇಷನ್ ಅಂಗಡಿಯಿಂದ ರೇಷನ್ ಪಡೆಯುವ ಬಗ್ಗೆ.' },
    aadhaar: { name: 'ಆಧಾರ್‌ಗೆ ಸಂಬಂಧಿಸಿದ ಕಾಗದ', about: 'ಇದು ಆಧಾರ್ ನಂಬರ್ ಅಥವಾ ಆಧಾರ್ ವಿವರಗಳ ಬಗ್ಗೆ.' },
    pan_card: { name: 'ಪ್ಯಾನ್‌ಗೆ ಸಂಬಂಧಿಸಿದ ಕಾಗದ', about: 'ಇದು ಪ್ಯಾನ್ (ತೆರಿಗೆ ಗುರುತಿನ) ನಂಬರ್ ಬಗ್ಗೆ.' },
    bank_notice: { name: 'ಬ್ಯಾಂಕ್ ಪತ್ರ', about: 'ಇದು ಬ್ಯಾಂಕ್‌ನಿಂದ ಬಂದ ಪತ್ರ ಅಥವಾ ಸೂಚನೆ.' },
    loan_notice: { name: 'ಸಾಲದ (ಲೋನ್) ಸೂಚನೆ', about: 'ಇದು ಒಂದು ಲೋನ್ ಅಥವಾ ಬಾಕಿ ಇರುವ ಹಣದ ಬಗ್ಗೆ.' },
    income_tax_notice: { name: 'ಆದಾಯ ತೆರಿಗೆ (ಇನ್‌ಕಮ್ ಟ್ಯಾಕ್ಸ್) ನೋಟಿಸ್', about: 'ಇದು ಆದಾಯ ತೆರಿಗೆ ಇಲಾಖೆಯಿಂದ ಬಂದಿದೆ.' },
    pension: { name: 'ಪಿಂಚಣಿ (ಪೆನ್ಷನ್) ಪತ್ರ', about: 'ಇದು ಪೆನ್ಷನ್ ಬಗ್ಗೆ.' },
    court_notice: { name: 'ಕೋರ್ಟ್ ಅಥವಾ ಕಾನೂನು ನೋಟಿಸ್', about: 'ಇದು ಕೋರ್ಟ್‌ನಿಂದ ಬಂದಿದೆ, ಅಥವಾ ಒಂದು ಕಾನೂನು ವಿಷಯದ ಬಗ್ಗೆ. ಇದನ್ನು ಹಗುರವಾಗಿ ತೆಗೆದುಕೊಳ್ಳಬೇಡಿ.' },
    land_record: { name: 'ಜಮೀನಿನ ದಾಖಲೆ', about: 'ಇದು ಜಮೀನು ಯಾರದು ಎಂಬುದರ ಬಗ್ಗೆ, ಅಥವಾ ಜಮೀನಿನ ವಿವರಗಳ ಬಗ್ಗೆ.' },
    property_tax: { name: 'ಆಸ್ತಿ ತೆರಿಗೆ (ಮನೆ ಕಂದಾಯ) ಬಿಲ್', about: 'ಇದು ಮನೆ ಅಥವಾ ಆಸ್ತಿಯ ತೆರಿಗೆ ಬಗ್ಗೆ.' },
    scholarship: { name: 'ವಿದ್ಯಾರ್ಥಿವೇತನ (ಸ್ಕಾಲರ್‌ಶಿಪ್) ಪತ್ರ', about: 'ಇದು ಓದಿಗಾಗಿ ಸಿಗುವ ಸ್ಕಾಲರ್‌ಶಿಪ್ ಬಗ್ಗೆ.' },
    farmer_scheme: { name: 'ರೈತರ ಯೋಜನೆಯ ಪತ್ರ', about: 'ಇದು ರೈತರಿಗಾಗಿ ಇರುವ ಒಂದು ಯೋಜನೆ ಅಥವಾ ಸಹಾಯದ ಬಗ್ಗೆ.' },
    school_letter: { name: 'ಶಾಲೆಯ ಪತ್ರ', about: 'ಇದು ಶಾಲೆಯಿಂದ ಬಂದಿದೆ, ಅಥವಾ ಓದಿನ ಬಗ್ಗೆ.' },
    marksheet: { name: 'ಅಂಕಪಟ್ಟಿ (ಮಾರ್ಕ್ಸ್ ಕಾರ್ಡ್) ಅಥವಾ ರಿಸಲ್ಟ್', about: 'ಇದರಲ್ಲಿ ಪರೀಕ್ಷೆಯ ಅಂಕಗಳು ಅಥವಾ ರಿಸಲ್ಟ್ ಇರುತ್ತದೆ.' },
    insurance: { name: 'ವಿಮೆ (ಇನ್ಶೂರೆನ್ಸ್) ಕಾಗದ', about: 'ಇದು ಒಂದು ಇನ್ಶೂರೆನ್ಸ್ ಪಾಲಿಸಿಯ ಬಗ್ಗೆ.' },
    traffic_challan: { name: 'ಟ್ರಾಫಿಕ್ ಚಲನ್', about: 'ಇದು ಟ್ರಾಫಿಕ್ ಅಥವಾ ವಾಹನ ನಿಯಮಕ್ಕೆ ಸಂಬಂಧಿಸಿದ ದಂಡ.' },
    job_notice: { name: 'ಉದ್ಯೋಗ ಅಥವಾ ಪರೀಕ್ಷೆಯ ಸೂಚನೆ', about: 'ಇದು ಸರ್ಕಾರಿ ಉದ್ಯೋಗ, ನೇಮಕಾತಿ ಅಥವಾ ಅದರ ಪರೀಕ್ಷೆಯ ಬಗ್ಗೆ.' },
    application_receipt: { name: 'ಅರ್ಜಿಯ ರಸೀದಿ', about: 'ಅರ್ಜಿ ತಲುಪಿದೆ ಎಂದು ಇದು ತೋರಿಸುತ್ತದೆ.' },
    application_decision: { name: 'ಅರ್ಜಿಯ ಬಗ್ಗೆ ಪತ್ರ', about: 'ಇದರಲ್ಲಿ ಒಂದು ಅರ್ಜಿಯ ಬಗ್ಗೆ ತೀರ್ಮಾನ ಅಥವಾ ಮಾಹಿತಿ ಇದೆ.' },
    government_notice: { name: 'ಸರ್ಕಾರಿ ಸೂಚನೆ', about: 'ಇದು ಒಂದು ಸರ್ಕಾರಿ ಕಚೇರಿಯಿಂದ ಬಂದ ಸೂಚನೆ ಅಥವಾ ಆದೇಶ.' },
    lab_report: { name: 'ವೈದ್ಯಕೀಯ ಪರೀಕ್ಷಾ ವರದಿ', about: 'ಇದರಲ್ಲಿ ರಕ್ತ ಅಥವಾ ಇತರ ವೈದ್ಯಕೀಯ ಪರೀಕ್ಷೆಗಳ ಫಲಿತಾಂಶಗಳಿವೆ.' },
    rental_agreement: { name: 'ಬಾಡಿಗೆ ಒಪ್ಪಂದ', about: 'ಇದು ಮನೆ ಮಾಲೀಕ ಮತ್ತು ಬಾಡಿಗೆದಾರರ ನಡುವಿನ ಒಪ್ಪಂದ.' },
    loan_agreement: { name: 'ಸಾಲ ಒಪ್ಪಂದ', about: 'ಇದರಲ್ಲಿ ಸಾಲದ ನಿಯಮಗಳಿವೆ: ಬಡ್ಡಿ, EMI ಮತ್ತು ಶುಲ್ಕಗಳು.' },
    contract: { name: 'ಒಂದು ಒಪ್ಪಂದ', about: 'ಇದು ಎರಡೂ ಕಡೆಯವರು ಪಾಲಿಸಬೇಕಾದ ನಿಯಮಗಳಿರುವ ಒಪ್ಪಂದ.' },
    unknown: { name: 'ಕಾಗದ', about: '' }
  },

  seedhiBaat: 'ಸರಳವಾಗಿ ಹೇಳಬೇಕೆಂದರೆ',
  docSays: 'ಕಾಗದದಲ್ಲಿ ಇರುವುದು',
  samjhoSays: 'ಸಮ್ಝೋ ವಿವರಣೆ',
  unclearText: 'ಈ ಭಾಗ ಸ್ಪಷ್ಟವಾಗಿಲ್ಲ — ದಯವಿಟ್ಟು ಮೂಲ ಕಾಗದ ನೋಡಿ.',

  aboutPerson: (name) => `ಈ ಕಾಗದ ಇವರ ಬಗ್ಗೆ: ${name}.`,
  issuedBy: (authority) => `ಇದು ಇಲ್ಲಿಂದ ಬಂದಿದೆ: ${authority}.`,
  status: {
    approved: 'ಅರ್ಜಿ ಮಂಜೂರಾಗಿದೆ.',
    rejected: 'ಅರ್ಜಿ ತಿರಸ್ಕಾರವಾಗಿದೆ (ರಿಜೆಕ್ಟ್ ಆಗಿದೆ).',
    pending: 'ಅರ್ಜಿ ಇನ್ನೂ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿದೆ. ಇನ್ನೂ ತೀರ್ಮಾನ ಆಗಿಲ್ಲ.',
    cancelled: 'ಇದನ್ನು ರದ್ದು ಮಾಡಲಾಗಿದೆ.'
  },
  dateSentence: {
    deadline: (d) => `ಕೊನೆಯ ದಿನಾಂಕ: ${d}.`,
    due: (d) => `ಹಣ ಕಟ್ಟಲು ಕೊನೆಯ ದಿನಾಂಕ: ${d}.`,
    hearing: (d) => `ಹಾಜರಾಗಲು ಕಾಗದದಲ್ಲಿ ಕೊಟ್ಟಿರುವ ದಿನಾಂಕ: ${d}.`,
    issue: (d) => `ಇದನ್ನು ${d} ರಂದು ನೀಡಲಾಗಿದೆ.`,
    validity: (d) => `ಇದು ${d} ವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ.`,
    birth: (d) => `ಬರೆದಿರುವ ಹುಟ್ಟಿದ ದಿನಾಂಕ: ${d}.`,
    other: (d) => `ಒಂದು ದಿನಾಂಕ ಬರೆದಿದೆ: ${d}.`
  },
  daysLeft: (days) => (days === 1 ? 'ಇನ್ನು 1 ದಿನ ಉಳಿದಿದೆ.' : `ಇನ್ನು ${days} ದಿನಗಳು ಉಳಿದಿವೆ.`),
  dueToday: 'ಈ ದಿನಾಂಕ ಇವತ್ತೇ.',
  datePassed: 'ಗಮನಿಸಿ: ಈ ದಿನಾಂಕ ಈಗಾಗಲೇ ಕಳೆದುಹೋಗಿದೆ.',
  amountSentence: {
    payable: (a) => `ಕಟ್ಟಬೇಕಾದ ಮೊತ್ತ: ${a}.`,
    income: (a) => `ಬರೆದಿರುವ ಆದಾಯ: ${a}.`,
    fine: (a) => `ಬರೆದಿರುವ ದಂಡ ಅಥವಾ ತಡ ಶುಲ್ಕ: ${a}.`,
    fee: (a) => `ಬರೆದಿರುವ ಫೀಸ್: ${a}.`,
    sanctioned: (a) => `ಮಂಜೂರಾದ ಅಥವಾ ಕಳುಹಿಸಿದ ಮೊತ್ತ: ${a}.`,
    other: (a) => `ಒಂದು ಮೊತ್ತ ಬರೆದಿದೆ: ${a}.`
  },
  actionsPointer: 'ಕಾಗದ ನಿಮಗೆ ಏನೋ ಮಾಡಲು ಹೇಳುತ್ತಿದೆ. ಕೆಳಗೆ "ನೀವು ಏನು ಮಾಡಬೇಕು" ನೋಡಿ.',
  noActionFound: 'ಕಾಗದ ನಿಮಗೆ ಏನಾದರೂ ಮಾಡಲು ಸ್ಪಷ್ಟವಾಗಿ ಹೇಳುತ್ತಿಲ್ಲ.',
  keepSafe: 'ಈ ಕಾಗದವನ್ನು ಜೋಪಾನವಾಗಿ ಇಟ್ಟುಕೊಳ್ಳಿ.',
  doBefore: (d) => `ಇದನ್ನು ${d} ದಿನಾಂಕಕ್ಕಿಂತ ಮೊದಲು ಮಾಡಿ.`,
  bringDocs: (list) => `ಈ ಕಾಗದಗಳನ್ನು ಸಿದ್ಧವಾಗಿಡಿ: ${list}.`,
  contactFor: (c) => `ಪ್ರಶ್ನೆ ಇದ್ದರೆ ಇಲ್ಲಿ ಕೇಳಿ: ${c}.`,
  warningPointer: 'ಕಾಗದದಲ್ಲಿ ಒಂದು ಎಚ್ಚರಿಕೆ ಇದೆ. ಅದನ್ನು ಗಮನವಿಟ್ಟು ಓದಿ.',
  rejectedNext: 'ಇದು ತಪ್ಪು ಎಂದು ನಿಮಗೆ ಅನಿಸಿದರೆ, ಈ ಪತ್ರ ಕಳುಹಿಸಿದ ಕಚೇರಿಯಲ್ಲಿ ಕೇಳಿ.',
  lowQuality: 'ಫೋಟೋ ಅಷ್ಟು ಸ್ಪಷ್ಟವಾಗಿರಲಿಲ್ಲ, ಹಾಗಾಗಿ ಕೆಲವು ವಿವರಗಳು ತಪ್ಪಾಗಿ ಓದಿರಬಹುದು. ಮೂಲ ಕಾಗದದೊಂದಿಗೆ ಹೋಲಿಸಿ ನೋಡಿ.',

  cardTodo: 'ನೀವು ಏನು ಮಾಡಬೇಕು',
  cardDates: 'ಮುಖ್ಯ ದಿನಾಂಕಗಳು',
  cardAmount: 'ಮೊತ್ತ',
  cardWhere: 'ಎಲ್ಲಿಗೆ ಹೋಗಬೇಕು',
  cardWarnings: 'ಎಚ್ಚರಿಕೆ',
  cardDocs: 'ಬೇಕಾದ ಕಾಗದಗಳು',
  cardPerson: 'ಯಾರ ಬಗ್ಗೆ',
  cardFrom: 'ಕಳುಹಿಸಿದವರು',
  cardNumbers: 'ಇಟ್ಟುಕೊಳ್ಳಬೇಕಾದ ನಂಬರ್‌ಗಳು',
  cardContact: 'ಸಂಪರ್ಕ',
  refKinds: {
    application: 'ಅರ್ಜಿ ನಂಬರ್',
    certificate: 'ಪ್ರಮಾಣಪತ್ರ ನಂಬರ್',
    consumer: 'ಗ್ರಾಹಕ ನಂಬರ್',
    account: 'ಖಾತೆ ನಂಬರ್',
    case: 'ಕೇಸ್ ನಂಬರ್',
    reference: 'ಪತ್ರ ನಂಬರ್',
    registration: 'ನೋಂದಣಿ ನಂಬರ್',
    receipt: 'ರಸೀದಿ ನಂಬರ್',
    other: 'ನಂಬರ್'
  },
  requiredDocNames: {
    aadhaar: 'ಆಧಾರ್ ಕಾರ್ಡ್',
    pan: 'ಪ್ಯಾನ್ ಕಾರ್ಡ್',
    ration_card: 'ರೇಷನ್ ಕಾರ್ಡ್',
    voter_id: 'ವೋಟರ್ ಐಡಿ',
    passbook: 'ಬ್ಯಾಂಕ್ ಪಾಸ್‌ಬುಕ್',
    photo: 'ಫೋಟೋ',
    income_certificate: 'ಆದಾಯ ಪ್ರಮಾಣಪತ್ರ',
    caste_certificate: 'ಜಾತಿ ಪ್ರಮಾಣಪತ್ರ',
    domicile_certificate: 'ವಾಸಸ್ಥಳ ಪ್ರಮಾಣಪತ್ರ',
    birth_certificate: 'ಜನನ ಪ್ರಮಾಣಪತ್ರ',
    land_record: 'ಜಮೀನಿನ ದಾಖಲೆ',
    electricity_bill: 'ಕರೆಂಟ್ ಬಿಲ್',
    address_proof: 'ವಿಳಾಸದ ಪುರಾವೆ',
    id_proof: 'ಗುರುತಿನ ಪುರಾವೆ',
    affidavit: 'ಅಫಿಡವಿಟ್',
    application_form: 'ಅರ್ಜಿ ಫಾರಂ'
  },

  voiceDownloadNote: 'ಮೊದಲ ಬಾರಿ ಧ್ವನಿ ಡೌನ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ (ಸುಮಾರು 58 MB). ನಂತರ ಇಂಟರ್ನೆಟ್ ಇಲ್ಲದೆಯೂ ಕೆಲಸ ಮಾಡುತ್ತದೆ.',

  listen: 'ಕೇಳಿ',
  pause: 'ಸ್ವಲ್ಪ ನಿಲ್ಲಿಸಿ',
  resume: 'ಮುಂದುವರಿಸಿ',
  stop: 'ನಿಲ್ಲಿಸಿ',
  noVoice: 'ಈ ಫೋನ್‌ನಲ್ಲಿ ಕನ್ನಡ ವಾಯ್ಸ್ ಇಲ್ಲ.',
  noVoiceHint: 'ಫೋನ್ ಸೆಟ್ಟಿಂಗ್ಸ್‌ನಲ್ಲಿ (Text-to-speech) ವಾಯ್ಸ್ ಸೇರಿಸಬಹುದು, ಅಥವಾ ಬೇರೆ ಭಾಷೆಯಲ್ಲಿ ಕೇಳಬಹುದು.',
  listenInHindi: 'ಹಿಂದಿಯಲ್ಲಿ ಕೇಳಿ',
  listenInEnglish: 'ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಕೇಳಿ',
  noSpeechSupport: 'ಈ ಬ್ರೌಸರ್‌ಗೆ ಗಟ್ಟಿಯಾಗಿ ಓದಿ ಹೇಳಲು ಆಗುವುದಿಲ್ಲ.',

  disclaimer: 'ಸಮ್ಝೋ ನಿಮ್ಮ ಕಾಗದವನ್ನು ಸರಳವಾಗಿ ವಿವರಿಸುತ್ತದೆ. ಮುಖ್ಯ ವಿವರಗಳನ್ನು ಯಾವಾಗಲೂ ಮೂಲ ಕಾಗದದೊಂದಿಗೆ ಅಥವಾ ಅದನ್ನು ನೀಡಿದ ಕಚೇರಿಯೊಂದಿಗೆ ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ. ಸಮ್ಝೋ ಸರ್ಕಾರಿ ಸೇವೆ ಅಲ್ಲ. ಇದು ಕಾನೂನು ಸಲಹೆಯೂ ಅಲ್ಲ.',
  fullText: 'ಸಮ್ಝೋ ಏನು ಓದಿದೆ',
  fullTextHint: 'ಬಣ್ಣ ಹಾಕಿದ ಸಾಲುಗಳನ್ನು ಸ್ಪಷ್ಟವಾಗಿ ಓದಲು ಆಗಲಿಲ್ಲ.',
  newDocument: 'ಹೊಸ ಕಾಗದ',
  save: 'ಈ ಫೋನ್‌ನಲ್ಲಿ ಸೇವ್ ಮಾಡಿ',
  saved: 'ಈ ಫೋನ್‌ನಲ್ಲಿ ಸೇವ್ ಆಗಿದೆ',
  share: 'ಶೇರ್ ಮಾಡಿ',
  copied: 'ಕಾಪಿ ಆಯಿತು',
  translateLines: 'ಕಾಗದದ ಇಂಗ್ಲಿಷ್ ಸಾಲುಗಳನ್ನು ಕನ್ನಡದಲ್ಲಿ ತೋರಿಸಿ',
  helperMode: 'ಸಹಾಯಕ ಮೋಡ್',
  helperModeHint: 'ಇತರರಿಗೆ ಕಾಗದ ಓದಿ ಹೇಳುವವರಿಗಾಗಿ (CSC, NGO, ಸ್ವಯಂಸೇವಕರು). ಇದರಲ್ಲಿ ಸೇವ್ ಆಫ್ ಆಗಿರುತ್ತದೆ, "ಮುಂದಿನ ವ್ಯಕ್ತಿ" ಒತ್ತಿದರೆ ಎಲ್ಲವೂ ಅಳಿಸಿಹೋಗುತ್ತದೆ.',
  nextPerson: 'ಮುಂದಿನ ವ್ಯಕ್ತಿ',
  listenMode: 'ಕೇಳುವ ಮೋಡ್',
  listenModeHint: 'ವಿವರಣೆ ಸಿದ್ಧವಾದ ಕೂಡಲೇ ಸಮ್ಝೋ ಅದನ್ನು ತಾನಾಗಿಯೇ ಓದಿ ಹೇಳುತ್ತದೆ.',
  settingsTitle: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  shareVoiceNote: 'ಧ್ವನಿ ಸಂದೇಶವಾಗಿ ಕಳುಹಿಸಿ',
  makingVoiceNote: 'ಧ್ವನಿ ಸಂದೇಶ ತಯಾರಾಗುತ್ತಿದೆ…',
  voiceNoteFailed: 'ಈ ಫೋನ್‌ನಲ್ಲಿ ಧ್ವನಿ ಸಂದೇಶ ಮಾಡಲು ಆಗಲಿಲ್ಲ.',
  translateOtherLines: 'ಕಾಗದದ ಇತರ ಭಾಷೆಯ ಸಾಲುಗಳನ್ನು ಕನ್ನಡದಲ್ಲಿ ತೋರಿಸಿ',
  translateAiNote: 'ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಇಲ್ಲದ ಸಾಲುಗಳನ್ನು ಒಂದು AI ಸೇವೆ (Groq) ಅನುವಾದಿಸುತ್ತದೆ.',
  translateConsent: 'ಅನುವಾದ ಮಾಡಲು, ಈ ಸಾಲುಗಳನ್ನು ಇಂಟರ್ನೆಟ್ ಮೂಲಕ ಸಮ್ಝೋ ಸರ್ವರ್‌ಗೆ ಕಳುಹಿಸಲಾಗುತ್ತದೆ. ಅಲ್ಲಿ ಅವು ಸೇವ್ ಆಗುವುದಿಲ್ಲ. ಆಧಾರ್, ಫೋನ್ ನಂತಹ ನಂಬರ್‌ಗಳನ್ನು ಮೊದಲೇ ತೆಗೆದುಹಾಕಲಾಗುತ್ತದೆ.',
  translateConfirm: 'ಹೌದು, ಅನುವಾದ ಮಾಡಿ',
  translating: 'ಅನುವಾದ ಆಗುತ್ತಿದೆ…',
  translateNote: 'ಯಂತ್ರದಿಂದ ಅನುವಾದ — ತಪ್ಪುಗಳು ಇರಬಹುದು.',
  translateFailed: 'ಈಗ ಅನುವಾದ ಸಿಗುತ್ತಿಲ್ಲ.',
  retryRotated: 'ಫೋಟೋ ತಿರುಗಿಸಿ ಮತ್ತೆ ಓದಿ',

  addToCalendar: 'ಕ್ಯಾಲೆಂಡರ್‌ಗೆ ಜ್ಞಾಪನೆ ಸೇರಿಸಿ',
  askTitle: 'ಈ ದಾಖಲೆಯ ಬಗ್ಗೆ ಕೇಳಿ',
  askHint: 'ನಿಮ್ಮದೇ ಮಾತಿನಲ್ಲಿ ಕೇಳಿ. ಸಮ್ಝೋ ನಿಮ್ಮ ದಾಖಲೆಯಿಂದ ಉತ್ತರಿಸುತ್ತದೆ — ಅಲ್ಲಿ ಇಲ್ಲದಿದ್ದರೆ, ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ಗಳಿಂದ ಮಾತ್ರ.',
  askPlaceholder: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಬರೆಯಿರಿ ಅಥವಾ ಹೇಳಿ…',
  askSend: 'ಕೇಳಿ',
  askMic: 'ಮಾತನಾಡಿ ಕೇಳಿ',
  askListening: 'ಕೇಳುತ್ತಿದೆ… ಈಗ ಮಾತನಾಡಿ',
  askWebToggle: 'ಅಗತ್ಯವಿದ್ದರೆ ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ಗಳನ್ನೂ ನೋಡಿ',
  askConsent: 'ಉತ್ತರಿಸಲು, ಈ ದಾಖಲೆಯ ಬರಹ ಮತ್ತು ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಇಂಟರ್ನೆಟ್ ಮೂಲಕ ಸಮ್ಝೋ ಸರ್ವರ್ ಮತ್ತು ಒಂದು AI ಸೇವೆಗೆ (Groq) ಕಳುಹಿಸಲಾಗುತ್ತದೆ. ಆಧಾರ್, ಪ್ಯಾನ್, ಫೋನ್ ನಂಬರ್, ಇಮೇಲ್ ಮೊದಲೇ ತೆಗೆದುಹಾಕಲಾಗುತ್ತದೆ. ಏನನ್ನೂ ಸೇವ್ ಮಾಡುವುದಿಲ್ಲ.',
  askOfficialOnly: 'ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ಗಳನ್ನು ಮಾತ್ರ ನೋಡಲಾಗುತ್ತದೆ, ಉದಾಹರಣೆಗೆ:',
  askConsentConfirm: 'ಸರಿ, ಕೇಳಿ',
  askThinkingDoc: 'ನಿಮ್ಮ ದಾಖಲೆಯನ್ನು ಓದುತ್ತಿದೆ',
  askThinkingWeb: 'ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ಗಳನ್ನು ನೋಡುತ್ತಿದೆ',
  askFromDoc: 'ನಿಮ್ಮ ದಾಖಲೆಯಿಂದ',
  askFromWeb: 'ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ನಿಂದ',
  askNotFound: 'ಇದು ನಿಮ್ಮ ದಾಖಲೆಯಲ್ಲಾಗಲಿ ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ಗಳಲ್ಲಾಗಲಿ ಸಮ್ಝೋಗೆ ಸಿಗಲಿಲ್ಲ. ಈ ದಾಖಲೆ ಕಳುಹಿಸಿದ ಕಚೇರಿಯನ್ನು ಕೇಳಿ.',
  askUnverified: 'ಇದನ್ನು ದಾಖಲೆಯ ನಿಖರ ಸಾಲಿನೊಂದಿಗೆ ಸಮ್ಝೋ ಹೊಂದಿಸಲು ಆಗಲಿಲ್ಲ. ದಾಖಲೆ ನೋಡಿ ಪರಿಶೀಲಿಸಿ.',
  askSources: 'ಮೂಲಗಳು',
  askOfficial: 'ಸರ್ಕಾರಿ',
  askFailed: 'ಈಗ ಉತ್ತರ ಸಿಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  askBusy: 'ಈಗ ತುಂಬಾ ಪ್ರಶ್ನೆಗಳು ಬರುತ್ತಿವೆ. ಒಂದು ನಿಮಿಷ ಬಿಟ್ಟು ಮತ್ತೆ ಕೇಳಿ.',
  askAiNote: 'ಈ ಉತ್ತರಗಳನ್ನು AI ಬರೆದಿದೆ, ತಪ್ಪುಗಳಿರಬಹುದು. ಮುಖ್ಯ ವಿಷಯಗಳನ್ನು ಕಚೇರಿಯಲ್ಲಿ ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.',
  askTryNext: 'ಇದನ್ನೂ ಕೇಳಬಹುದು:',
  askJump: 'ಪ್ರಶ್ನೆ ಕೇಳಿ',
  askSuggest: {
    fillForm: 'ಈ ಫಾರ್ಮ್ ಅನ್ನು ಹೇಗೆ ತುಂಬುವುದು? ಪ್ರತಿ ಕಾಲಂ ಅನ್ನು ವಿವರಿಸಿ.',
    first: 'ನಾನು ಮೊದಲು ಏನು ಮಾಡಬೇಕು?',
    deadline: 'ಕೊನೆಯ ದಿನಾಂಕ ತಪ್ಪಿದರೆ ಏನಾಗುತ್ತದೆ?',
    pay: 'ಇದನ್ನು ಹೇಗೆ, ಎಲ್ಲಿ ಪಾವತಿಸಬೇಕು?',
    papers: 'ಈ ದಾಖಲೆಗಳನ್ನು ಎಲ್ಲಿ ಪಡೆಯಬೇಕು?',
    rejected: 'ಇದು ಏಕೆ ತಿರಸ್ಕರಿಸಲಾಯಿತು, ಈಗ ನಾನು ಏನು ಮಾಡಬಹುದು?',
    meaning: 'ಈ ದಾಖಲೆಯನ್ನು ತುಂಬಾ ಸರಳ ಮಾತುಗಳಲ್ಲಿ ವಿವರಿಸಿ.',
    contact: 'ಇದರ ಬಗ್ಗೆ ಯಾರನ್ನು ಸಂಪರ್ಕಿಸಬೇಕು?',
    schemes: 'ಈ ದಾಖಲೆಯ ಪ್ರಕಾರ ನಾನು ಯಾವ ಸರ್ಕಾರಿ ಯೋಜನೆಗಳಿಗೆ ಅರ್ಹನಾಗಬಹುದು?'
  },

  helpTitle: 'ಸಹಾಯ ಪಡೆಯಿರಿ',
  nearbyTitle: 'ಹತ್ತಿರದ ಕಚೇರಿ',
  nearbyNote: 'ನಿಮ್ಮ ಹತ್ತಿರದ ನಕ್ಷೆ ತೆರೆಯುತ್ತದೆ. ನಿಮ್ಮ ಸ್ಥಳ ನಕ್ಷೆಗೆ ಮಾತ್ರ ಹೋಗುತ್ತದೆ — ಸಮ್ಝೋ ಅದನ್ನು ನೋಡುವುದಿಲ್ಲ, ಸೇವ್ ಮಾಡುವುದಿಲ್ಲ.',
  locating: 'ನಿಮ್ಮ ಸ್ಥಳ ಹುಡುಕುತ್ತಿದೆ…',
  schemesTitle: 'ಸರ್ಕಾರಿ ಯೋಜನೆಗಳು',
  schemesText: 'ಈ ದಾಖಲೆಯ ಪ್ರಕಾರ ಯಾವ ಯೋಜನೆಗಳು ನಿಮಗೆ ಉಪಯೋಗವಾಗಬಹುದು ಎಂದು ಸಮ್ಝೋ ಸರ್ಕಾರಿ ಯೋಜನೆಗಳ ವೆಬ್‌ಸೈಟ್‌ಗಳಲ್ಲಿ ನೋಡಬಹುದು.',
  schemesButton: 'ನನಗಾಗಿ ಯೋಜನೆಗಳನ್ನು ಹುಡುಕಿ',
  legalTitle: 'ಉಚಿತ ಕಾನೂನು ಸಹಾಯ',
  legalText: 'ಕಾನೂನು ಸೇವೆಗಳ ಪ್ರಾಧಿಕಾರದಿಂದ ನಿಮಗೆ ಉಚಿತ ವಕೀಲರು ಸಿಗಬಹುದು — ಉದಾಹರಣೆಗೆ ಮಹಿಳೆಯರು, ಮಕ್ಕಳು, SC/ST, ಕಾರ್ಮಿಕರು, ಅಂಗವಿಕಲರು ಮತ್ತು ಕಡಿಮೆ ಆದಾಯದವರು.',
  legalCall: (n) => `${n}ಗೆ ಕರೆ ಮಾಡಿ (ಉಚಿತ)`,
  legalNearby: 'ಹತ್ತಿರದ ಕಾನೂನು ಸೇವೆಗಳ ಪ್ರಾಧಿಕಾರ',
  legalMore: 'ಇನ್ನಷ್ಟು ಕಾನೂನು ನೆರವು',
  legalAskConsent: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಇಂಟರ್ನೆಟ್ ಮೂಲಕ ಸಮ್ಝೋ ಸರ್ವರ್ ಮತ್ತು ಒಂದು AI ಸೇವೆಗೆ (Groq) ಕಳುಹಿಸಲಾಗುತ್ತದೆ; ಅವು ಉತ್ತರವನ್ನು ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್‌ಗಳಲ್ಲಿ ಮಾತ್ರ ಹುಡುಕುತ್ತವೆ. ಆಧಾರ್, ಪ್ಯಾನ್, ಫೋನ್ ನಂಬರ್, ಇಮೇಲ್ ಮೊದಲೇ ತೆಗೆದುಹಾಕಲಾಗುತ್ತದೆ. ಏನನ್ನೂ ಸೇವ್ ಮಾಡುವುದಿಲ್ಲ.',
  navLegal: 'ಕಾನೂನು ನೆರವು'
}
